import { Link } from "react-router-dom";
import { Question } from "@phosphor-icons/react";

/**
 * HelpLink — a tiny (?) icon that deep-links into the User's Guide.
 *
 * Usage:
 *   <HelpLink anchor="six-doors" label="Recording an asset" />
 *
 * Place next to a page H1 or section header. Hover shows the section label,
 * click navigates to /help#<anchor>. Keeps documentation one click away
 * without crowding the page chrome.
 */
export default function HelpLink({ anchor, label }) {
  return (
    <Link
      to={`/help#${anchor}`}
      title={label ? `Help: ${label}` : "Open the User's Guide"}
      aria-label={label ? `Help: ${label}` : "Open the User's Guide"}
      data-testid={`help-link-${anchor}`}
      className="inline-flex items-center justify-center w-6 h-6 border border-[#E0DDD6] text-[#5C5F58] hover:text-[#1A3622] hover:border-[#1A3622] transition-colors"
    >
      <Question size={12} weight="bold" />
    </Link>
  );
}
